// extracted by mini-css-extract-plugin
export default {"root":"NodeModal_root__xAHii","tips":"NodeModal_tips__yDjkz","mt":"NodeModal_mt__uAFwu"};